var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_282)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -3.99792,
    y: -4.00006,
    width: 38.7244,
    height: 46.8399
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_1_74_282_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4,
    d: "M2.00155 0.0106366C2.92463 -0.0904886 3.7125 0.547132 4.45991 1.00379C13.0232 6.23782 21.1595 12.234 29.6876 17.533C31.0727 18.4835 31.0727 20.3709 29.6876 21.3214C21.1595 26.6215 13.0232 32.6166 4.45991 37.8506C3.4591 38.4627 2.74044 39.1301 1.49689 38.7064C0.65792 38.4201 0.0585034 37.7026 0.0020752 36.801L0.00526925 1.95118C0.100026 0.94631 1.02311 0.118149 2.00155 0.0106366Z",
    fill: "#422A7E",
    fillOpacity: 0.64
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_74_282_clip_path",
    transform: "translate(3.99792 4.00006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00155 0.0106366C2.92463 -0.0904886 3.7125 0.547132 4.45991 1.00379C13.0232 6.23782 21.1595 12.234 29.6876 17.533C31.0727 18.4835 31.0727 20.3709 29.6876 21.3214C21.1595 26.6215 13.0232 32.6166 4.45991 37.8506C3.4591 38.4627 2.74044 39.1301 1.49689 38.7064C0.65792 38.4201 0.0585034 37.7026 0.0020752 36.801L0.00526925 1.95118C0.100026 0.94631 1.02311 0.118149 2.00155 0.0106366Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.7246,
    height: 38.8406,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/layer_1.2827ad9516bba4a54e825426a380029b.svg";
export { ForwardRef as ReactComponent };